"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("./utils");
function GoogleAnalytics() {
  if (typeof window === 'undefined') {
    return function () {};
  }
  if (typeof window.ga !== 'function') {
    /* tslint:disable: no-console */
    console.warn("\n    [@redux-beacon/google-analytics] Analytics are not being tracked, window.ga \n    is not a function. Please include the Analytics Tag snippet:\n    https://support.google.com/analytics/answer/1008080    \n    ");
    return function () {};
  }
  return function target(events) {
    events.forEach(function (event) {
      var customTrackers = event.customTrackerId || event.tracker;
      var trackerIdsRaw = Array.isArray(customTrackers) ? customTrackers : [customTrackers];
      var trackerIds = trackerIdsRaw.map(function (trackerId) {
        return !!trackerId && !!trackerId.trim() ? trackerId + "." : '';
      });
      var ecommPluginType = event.ecommType === 'enhanced' ? 'ec' : 'ecommerce';
      trackerIds.forEach(function (trackerId) {
        if (utils_1.isEcommEvent(event)) {
          var callEvent = function (type) {
            return {
              addItem: function () {
                return ga("" + trackerId + ecommPluginType + ":addItem", utils_1.filterEcommEvents(event));
              },
              addTransaction: function () {
                return ga("" + trackerId + ecommPluginType + ":addTransaction", utils_1.filterEcommEvents(event));
              },
              addImpression: function () {
                return ga("" + trackerId + ecommPluginType + ":addImpression", utils_1.filterEcommEvents(event));
              },
              addProduct: function () {
                return ga("" + trackerId + ecommPluginType + ":addProduct", utils_1.filterEcommEvents(event));
              },
              addPromo: function () {
                return ga("" + trackerId + ecommPluginType + ":addPromo", utils_1.filterEcommEvents(event));
              },
              addAction: function () {
                return ga("" + trackerId + ecommPluginType + ":setAction", event.actionName, utils_1.filterEcommEvents(event));
              },
              ecommClear: function () {
                return ga("" + trackerId + ecommPluginType + ":clear");
              },
              ecommSend: function () {
                return ga("" + trackerId + ecommPluginType + ":send");
              }
            }[type]();
          };
          callEvent(event.hitType);
        } else {
          if (event.hitType === 'pageview') {
            ga(trackerId + "set", 'page', event.page);
          }
          ga(trackerId + "send", utils_1.removeKeys(event, ['customTrackerId']));
        }
      });
    });
  };
}
exports.default = GoogleAnalytics;